import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { NotificationView } from '@components/notifications';
import LoadingSpinner from '@components/common/LoadingSpinner';
import { setNotificationMsgAction, setPrimaryNotificationMsgAction } from '../store/actions';

const LayoutView = ({
  children,
  setNotificationMsg,
  isFetching,
  msg,
  msgType,
  nodeTypeMessage,
  autoHideMsg,
  closeOnBlur,
  onClose,
  onPrimaryClose,
  primaryNotification,
  primaryNotificationType,
  nodeTypePrimaryNotification,
  setPrimaryNotificationMsg
}) => {
  return (
    <>
      <NotificationView
        message={msg}
        messageType={msgType}
        nodeTypeMessage={nodeTypeMessage}
        autoHideMsg={autoHideMsg}
        closeOnBlur={closeOnBlur}
        onClose={() => {
          setNotificationMsg('');
          onClose();
        }}
        primaryNotification={primaryNotification}
        primaryNotificationType={primaryNotificationType}
        nodeTypePrimaryNotification={nodeTypePrimaryNotification}
        onPrimaryClose={() => {
          setPrimaryNotificationMsg('');
          onPrimaryClose();
        }}
      />
      <LoadingSpinner loading={isFetching} />
      {children}
    </>
  );
};

LayoutView.propTypes = {
  children: PropTypes.node.isRequired,
  setNotificationMsg: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  msg: PropTypes.string,
  msgType: PropTypes.string.isRequired,
  nodeTypeMessage: PropTypes.bool.isRequired,
  autoHideMsg: PropTypes.bool.isRequired,
  closeOnBlur: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onPrimaryClose: PropTypes.func.isRequired,
  primaryNotification: PropTypes.string.isRequired,
  primaryNotificationType: PropTypes.string.isRequired,
  nodeTypePrimaryNotification: PropTypes.bool.isRequired,
  setPrimaryNotificationMsg: PropTypes.func.isRequired
};

LayoutView.defaultProps = {
  msg: null
};

function mapStateToProps(state) {
  return {
    isFetching: state.network.isFetching,
    msg: state.notification.msg,
    msgType: state.notification.msgType,
    nodeTypeMessage: state.notification.nodeTypeMessage,
    autoHideMsg: state.notification.autoHideMsg,
    closeOnBlur: state.notification.closeOnBlur,
    onClose: state.notification.onClose,
    onPrimaryClose: state.notification.onPrimaryClose,
    primaryNotification: state.notification.primaryNotification,
    primaryNotificationType: state.notification.primaryNotificationType,
    nodeTypePrimaryNotification: state.notification.nodeTypePrimaryNotification
  };
}

export default connect(mapStateToProps, {
  setNotificationMsg: setNotificationMsgAction,
  setPrimaryNotificationMsg: setPrimaryNotificationMsgAction
})(LayoutView);
